import PageTransition from '../../common/page/page-transition';


class DefaultPageTransition extends PageTransition {

}


export default DefaultPageTransition;
